var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "120.4 112 459.2 336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m130.55 112c-5.5039 0.51953-10.176 5.668-10.148 11.199v313.6c0 5.8633 5.3359 11.199 11.199 11.199h436.8c5.8633 0 11.199-5.3359 11.199-11.199v-313.6c0-5.8633-5.3359-11.199-11.199-11.199h-437.85zm12.25 22.398h414.4v271.95l-98.176-120.93c-2.3281-2.8398-6.1367-4.4023-9.8008-4.0234-3.0195 0.33594-5.875 1.957-7.6992 4.375l-61.949 80.152-127.75-136.5c-2.293-2.4375-5.7422-3.7656-9.1016-3.5-2.8867 0.25781-5.6484 1.6719-7.5234 3.8477l-92.398 105zm347.2 33.602c-18.426 0-33.602 15.176-33.602 33.602 0 18.426 15.176 33.602 33.602 33.602s33.602-15.176 33.602-33.602c0-18.426-15.176-33.602-33.602-33.602z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoto);
export default __webpack_public_path__ + "static/media/icon-photo.3764360bdc4502b68467999198bed201.svg";
export { ForwardRef as ReactComponent };